import { render, staticRenderFns } from "./manualDetails.vue?vue&type=template&id=39d52e62&scoped=true&"
import script from "./manualDetails.vue?vue&type=script&lang=js&"
export * from "./manualDetails.vue?vue&type=script&lang=js&"
import style0 from "./manualDetails.vue?vue&type=style&index=0&id=39d52e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d52e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d52e62')) {
      api.createRecord('39d52e62', component.options)
    } else {
      api.reload('39d52e62', component.options)
    }
    module.hot.accept("./manualDetails.vue?vue&type=template&id=39d52e62&scoped=true&", function () {
      api.rerender('39d52e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/manualDetails.vue"
export default component.exports